import { Image, Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const SingleBrand = (
  { BrandDetails }: { BrandDetails: any },
  props: any
): ReactElement => {
  const [getBrandDetails, setBrandDetails] = useState(undefined);

  useEffect(() => {
    // BrandDetails();
    setBrandDetails(BrandDetails);
  }, [BrandDetails]);

  return (
    <React.Fragment>
      <Row gutter={20}>
        <Col span={24}>
          <Image src={getBrandDetails?.logo} className="rounded" />
        </Col>
        <Col span={24}>
          <h3 className="title mt-4">Basic Information</h3>
          <div className="inner-body-wrapper">
            <div className="inner-body">
              <div className="single">
                <div className="info-name">
                  <span>Brand Name</span>
                </div>
                <div className="info-desc">
                  <span>{getBrandDetails?.name}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Brand ID</span>
                </div>

                <div className="info-desc">
                  <span>{getBrandDetails?.id}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Type</span>
                </div>
                <div className="info-desc">
                  <span>{getBrandDetails?.type?.replace("_", " ")}</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SingleBrand.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SingleBrand;
